module.exports = __webpack_public_path__ + "static/itch.io-bd462adbfaef6a86cceaf1c7ca1e7b7b.png";